import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import {
  HttpResponse,
  TotalMatchedCandidatesForActiveJobsResponse,
} from "@/types";

export function useGetTotalMatchedCandidatesForActiveJobs() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["totalMatchedCandidatesForActiveJobs", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/total-matched-candidates-for-active-jobs`;
      const res = await httpClient.get<
        TotalMatchedCandidatesForActiveJobsResponse,
        HttpResponse<TotalMatchedCandidatesForActiveJobsResponse>
      >(path);
      return res.data;
    },
  });
}
